module.exports = __webpack_public_path__ + "static/media/33-5.d81c3a42.mp3";